import React, { useEffect, useState, useRef, useContext } from "react";

import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import useSettings from "../../hooks/useSettings";
import { toast } from "../../services/toast";
import { makeStyles } from 'tss-react/mui';
import { AuthContext } from "../../context/Auth/AuthContext";
import { head } from "lodash";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import CircularProgress from "@mui/material/CircularProgress";
import CloseReasonModal from "../CloseReasonModal";
import { green } from "@mui/material/colors";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import SettingsCard from "./SettingsCard";



const useStyles = makeStyles()((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },
  rows: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 280px",
    alignItems: "center",
    gap: theme.spacing(3),
    padding: theme.spacing(1.5, 0),
    "& + &": {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(1),
    },
  },
  rowText: {
    minWidth: 0,
  },
  rowTitle: {
    fontSize: 13.5,
    fontWeight: 600,
  },
  rowHelp: {
    fontSize: 12.5,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  rowControl: {
    width: "100%",
  },
  colorControl: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  colorSwatch: {
    flexShrink: 0,
    width: 40,
    height: 40,
    padding: 3,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    background: "transparent",
    cursor: "pointer",
  },
  mono: {
    fontFamily: "monospace",
  },
  logoDropzone: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(1, 1.5),
    height: 40,
    cursor: "pointer",
    color: theme.palette.text.secondary,
    transition: "border-color .15s, background-color .15s",
    "&:hover": { borderColor: theme.palette.primary.main },
  },
  logoDropzoneActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
  logoImg: {
    height: 26,
    maxWidth: 90,
    objectFit: "contain",
  },
  logoHint: {
    fontSize: 11,
    lineHeight: 1.2,
    flex: 1,
  },
  extraAttr: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  textField: {
    flex: 1,
  },
  actions: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const COLOR_POR_DEFECTO = "#a13a3a";

const esColor = (v) => /^#[0-9a-f]{6}$/i.test(String(v ?? "").trim());

export default function Options(props) {
  const { settings } = props;
  const { classes, cx } = useStyles();

  const [brandColor, setBrandColor] = useState(COLOR_POR_DEFECTO);
  const [loadingBrandColor, setLoadingBrandColor] = useState(false);
  const [callType, setCallType] = useState("enabled");
  const [chatbotType, setChatbotType] = useState("");
  const [CheckMsgIsGroup, setCheckMsgIsGroupType] = useState("enabled");
  const [activitylog, setActivitylog] = useState("enabled");

  const [slaFirstReply, setSlaFirstReply] = useState("5");
  const [slaWait, setSlaWait] = useState("5");
  const [slaHandle, setSlaHandle] = useState("30");


  

  const [loadingCallType, setLoadingCallType] = useState(false);
  const [loadingChatbotType, setLoadingChatbotType] = useState(false);
  const [loadingCheckMsgIsGroup, setCheckMsgIsGroup] = useState(false);
  const [loadingActivitylog, setLoadingActivitylog] = useState(false);
  const [closeReasonModalOpen, setCloseReasonModalOpen] = useState(false);

  const [apiConnected, setApiConnected] = useState("");
  const [loadingApiConnect, setLoadingApiConnect] = useState(false);


  const attachmentFile = useRef(null);
  const [logoDragOver, setLogoDragOver] = useState(false);
  const [logo, setLogo] = useState(`${process.env.REACT_APP_BACKEND_URL}/public/logos/logo.png`);



  const { user } = useContext(AuthContext);
  const { companyId } = user;


  const { update } = useSettings();

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      const leerObjetivo = (k, d) => settings.find((x) => x.key === k)?.value ?? d;
      setSlaFirstReply(leerObjetivo("slaFirstReplyMinutes", "5"));
      setSlaWait(leerObjetivo("slaWaitMinutes", "5"));
      setSlaHandle(leerObjetivo("slaHandleMinutes", "30"));
      const color = leerObjetivo("brandColor", COLOR_POR_DEFECTO);
      setBrandColor(esColor(color) ? color : COLOR_POR_DEFECTO);

      const callType = settings.find((s) => s.key === "call");
      if (callType) {
        setCallType(callType.value);
      }
      const CheckMsgIsGroup = settings.find((s) => s.key === "CheckMsgIsGroup");
      if (CheckMsgIsGroup) {
        setCheckMsgIsGroupType(CheckMsgIsGroup.value);
      }
      const chatbotType = settings.find((s) => s.key === "chatBotType");
      if (chatbotType) {
        setChatbotType(chatbotType.value);
      }



      const logoEnterprise = settings.find((s) => s.key === "logo");
      if (logoEnterprise) {
        setLogo(`${process.env.REACT_APP_BACKEND_URL}/public/logos/${logoEnterprise.value}`)

      }

      const apiConnected = settings.find((s) => s.key === "apiConnected");
      if (apiConnected) {
        setApiConnected(apiConnected.value);
      }

    }
  }, [settings]);

  async function guardarColor() {
    if (!esColor(brandColor)) return;

    setLoadingBrandColor(true);
    await update({ key: "brandColor", value: brandColor });
    toast.success("Actualizacion exitosa.");
    setLoadingBrandColor(false);
  }

  async function handleCallType(value) {
    setCallType(value);
    setLoadingCallType(true);
    await update({
      key: "call",
      value,
    });
    toast.success("Actualizacion exitosa.");
    setLoadingCallType(false);
  }

  async function handleChatbotType(value) {
    setChatbotType(value);
    setLoadingChatbotType(true);
    await update({
      key: "chatBotType",
      value,
    });
    toast.success("Actualizacion exitosa.");
    setLoadingChatbotType(false);
  }

  async function handleGroupType(value) {
    setCheckMsgIsGroupType(value);
    setCheckMsgIsGroup(true);
    await update({
      key: "CheckMsgIsGroup",
      value,
    });
    toast.success("Actualizacion exitosa.");
    setCheckMsgIsGroup(false);

  }

  async function guardarObjetivo(key, value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return;
    await update({ key, value: String(n) });
    toast.success("Actualizacion exitosa.");
  }

  async function handleActivityLog(value) {
    setActivitylog(value);
    setLoadingActivitylog(true);
    await update({
      key: "activitylog",
      value,
    });
    toast.success("Actualizacion exitosa.");
    setLoadingActivitylog(false);

  }

  


  async function handleChangeApiConnected(value) {
    setApiConnected(value);
    setLoadingApiConnect(true);
    await update({
      key: "apiConnected",
      value,
    });
    toast.success("Actualizacion exitosa.");
    setLoadingApiConnect(false);
  }

  async function uploadLogo(file) {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    await api.post(`/settings/${companyId}/media-upload`, formData);
    setLogo(URL.createObjectURL(file));
    toast.success("Actualizacion exitosa.");
  }

  function handleAttachmentFile(e) {
    uploadLogo(head(e.target.files));
  }

  function handleLogoDrop(e) {
    e.preventDefault();
    setLogoDragOver(false);
    uploadLogo(head(e.dataTransfer.files));
  }


  const renderRow = (labelKey, helpKey, control) => (
    <div className={classes.row}>
      <div className={classes.rowText}>
        <div className={classes.rowTitle}>{i18n.t(labelKey)}</div>
        {helpKey && <div className={classes.rowHelp}>{i18n.t(helpKey)}</div>}
      </div>
      <div className={classes.rowControl}>{control}</div>
    </div>
  );

  const renderSelect = (labelKey, value, onChange, options, loadingFlag, helpKey) =>
    renderRow(
      labelKey,
      helpKey,
      <TextField
        select
        size="small"
        fullWidth
        value={value}
        disabled={loadingFlag}
        onChange={(e) => onChange(e.target.value)}
        slotProps={{ htmlInput: { "aria-label": i18n.t(labelKey) } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {i18n.t(opt.labelKey)}
          </MenuItem>
        ))}
      </TextField>
    );

  const renderObjetivo = (labelKey, key, value, setter) =>
    renderRow(
      labelKey,
      "settings.optionsTab.slaHelp",
      <TextField
        size="small"
        fullWidth
        value={value}
        onChange={(e) => setter(e.target.value.replace(/\D/g, ""))}
        onBlur={() => guardarObjetivo(key, value)}
        slotProps={{
          htmlInput: { inputMode: "numeric", "aria-label": i18n.t(labelKey) },
          input: { endAdornment: <InputAdornment position="end">min</InputAdornment> },
        }}
      />
    );

  return (
    <div className={classes.wrapper}>
      <CloseReasonModal
        open={closeReasonModalOpen}
        onClose={() => setCloseReasonModalOpen(false)}
      />

      <SettingsCard
        icon={PaletteOutlinedIcon}
        title={i18n.t("settings.optionsTab.sections.appearance.title")}
        subtitle={i18n.t("settings.optionsTab.sections.appearance.subtitle")}
      >
        <div className={classes.rows}>
          <div className={classes.row}>
            <div className={classes.rowText}>
              <div className={classes.rowTitle}>{i18n.t("settings.optionsTab.brandColor")}</div>
              <div className={classes.rowHelp}>
                {loadingBrandColor ? i18n.t("settings.optionsTab.updating") : i18n.t("settings.optionsTab.brandColorHelp")}
              </div>
            </div>
            <div className={cx(classes.rowControl, classes.colorControl)}>
              <input
                type="color"
                className={classes.colorSwatch}
                value={esColor(brandColor) ? brandColor : COLOR_POR_DEFECTO}
                onChange={(e) => setBrandColor(e.target.value)}
                onBlur={guardarColor}
                aria-label={i18n.t("settings.optionsTab.brandColor")}
              />
              <TextField
                size="small"
                fullWidth
                value={brandColor}
                onChange={(e) => setBrandColor(e.target.value.trim())}
                onBlur={guardarColor}
                error={!esColor(brandColor)}
                slotProps={{ htmlInput: { maxLength: 7, className: classes.mono } }}
              />
            </div>
          </div>

          <div className={classes.row}>
            <div className={classes.rowText}>
              <div className={classes.rowTitle}>{i18n.t("settings.optionsTab.logo")}</div>
              <div className={classes.rowHelp}>{i18n.t("settings.optionsTab.logoHelp")}</div>
            </div>
            <div className={classes.rowControl}>
              <input
                type="file"
                accept=".png,.jpg,.jpeg"
                ref={attachmentFile}
                onChange={(e) => handleAttachmentFile(e)}
                style={{ display: "none" }}
              />
              <div
                className={cx(classes.logoDropzone, {
                  [classes.logoDropzoneActive]: logoDragOver,
                })}
                onClick={() => attachmentFile.current.click()}
                onDragOver={(e) => { e.preventDefault(); setLogoDragOver(true); }}
                onDragLeave={() => setLogoDragOver(false)}
                onDrop={handleLogoDrop}
              >
                <img src={logo} alt="logo" className={classes.logoImg} loading="lazy" />
                <div className={classes.logoHint}>
                  {i18n.t("settings.optionsTab.logoDrop")}
                </div>
                <AttachFileIcon fontSize="small" />
              </div>
            </div>
          </div>
        </div>
      </SettingsCard>

      <SettingsCard
        icon={SmartToyOutlinedIcon}
        title={i18n.t("settings.optionsTab.sections.botBehavior.title")}
        subtitle={i18n.t("settings.optionsTab.sections.botBehavior.subtitle")}
      >
        <div className={classes.rows}>
          {renderSelect(
            "settings.optionsTab.chatbotType.label", chatbotType, handleChatbotType,
            [
              { value: "text", labelKey: "settings.optionsTab.chatbotType.text" },
              { value: "button", labelKey: "settings.optionsTab.chatbotType.button" },
              { value: "list", labelKey: "settings.optionsTab.chatbotType.list" },
            ],
            loadingChatbotType,
            "settings.optionsTab.chatbotType.help"
          )}
          {renderSelect(
            "settings.optionsTab.ignoreGroupMsgs.label", CheckMsgIsGroup, handleGroupType,
            [
              { value: "disabled", labelKey: "settings.optionsTab.ignoreGroupMsgs.disabled" },
              { value: "enabled", labelKey: "settings.optionsTab.ignoreGroupMsgs.enabled" },
            ],
            loadingCheckMsgIsGroup,
            "settings.optionsTab.ignoreGroupMsgs.help"
          )}
        </div>
      </SettingsCard>

      <SettingsCard
        icon={SupportAgentOutlinedIcon}
        title={i18n.t("settings.optionsTab.sections.serviceAndSla.title")}
        subtitle={i18n.t("settings.optionsTab.sections.serviceAndSla.subtitle")}
      >
        <div className={classes.rows}>
          {renderSelect(
            "settings.optionsTab.callType.label", callType, handleCallType,
            [
              { value: "disabled", labelKey: "settings.optionsTab.callType.disabled" },
              { value: "enabled", labelKey: "settings.optionsTab.callType.enabled" },
            ],
            loadingCallType,
            "settings.optionsTab.callType.help"
          )}
          {renderObjetivo("settings.optionsTab.slaFirstReply", "slaFirstReplyMinutes", slaFirstReply, setSlaFirstReply)}
          {renderObjetivo("settings.optionsTab.slaWait", "slaWaitMinutes", slaWait, setSlaWait)}
          {renderObjetivo("settings.optionsTab.slaHandle", "slaHandleMinutes", slaHandle, setSlaHandle)}
        </div>
      </SettingsCard>

      <SettingsCard
        icon={ConfirmationNumberOutlinedIcon}
        title={i18n.t("settings.optionsTab.sections.tickets.title")}
        subtitle={i18n.t("settings.optionsTab.sections.tickets.subtitle")}
      >
        <div className={classes.rows}>
          {renderSelect(
            "settings.optionsTab.activityLog.label", activitylog, handleActivityLog,
            [
              { value: "disabled", labelKey: "settings.optionsTab.activityLog.disabled" },
              { value: "enabled", labelKey: "settings.optionsTab.activityLog.enabled" },
            ],
            loadingActivitylog,
            "settings.optionsTab.activityLog.help"
          )}
          {renderRow(
            "settings.optionsTab.activityLog.manageReasons",
            "settings.optionsTab.activityLog.manageReasonsHelp",
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => setCloseReasonModalOpen(true)}
            >
              {i18n.t("settings.optionsTab.activityLog.manage")}
            </Button>
          )}
        </div>
      </SettingsCard>
    </div>
  );
}
